import React, { FC, memo } from "react";
import { Input } from "antd/lib";
import { GroupBlockEntityType } from "../../../../configMap";
import useEditEntityText from "../../hooks/useEditEntityText";

type EditEntityTextProps = {
  entityType: GroupBlockEntityType;
  documentId: string;
  annotationId: string;
  defaultValue: string;
  groupBlockIndex: number;
  isTableMode: boolean;
};

const EditEntityText: FC<EditEntityTextProps> = ({
  entityType,
  documentId,
  annotationId,
  defaultValue,
  groupBlockIndex,
  isTableMode,
}: EditEntityTextProps) => {
  const {
    value,
    handleChange,
    handleEnter,
    onBlur,
    handleCancel,
    handleClick,
    handleKeyEvent,
  } = useEditEntityText({
    entityType,
    documentId,
    annotationId,
    defaultValue,
    groupBlockIndex,
    isTableMode,
  });

  if (isTableMode) {
    return (
      <div className="edit-entity--table edit-entity-text">
        <Input
          size={"small"}
          defaultValue={defaultValue}
          value={value}
          onChange={handleChange}
          onPressEnter={handleEnter}
          onBlur={onBlur}
          autoFocus
          onClick={handleClick}
          onKeyDown={handleKeyEvent}
          autoComplete="off"
        />
        <div className="edit-actions">
          <i className="bi bi-slash-circle cancel" onMouseDown={handleCancel} />
          <i className="bi bi-check-lg submit" onMouseDown={handleEnter} />
        </div>
      </div>
    );
  }

  return (
    <span className="edit-entity--side edit-entity-text">
      <Input
        size={"small"}
        defaultValue={defaultValue}
        value={value}
        onChange={handleChange}
        onPressEnter={handleEnter}
        onBlur={onBlur}
        autoFocus
        onClick={(e) => e.stopPropagation()}
        onKeyDown={handleKeyEvent}
        autoComplete="off"
      />
      <span className="edit-entity-actions">
        <i className="bi bi-slash-circle cancel" onMouseDown={handleCancel} />
        <i className="bi bi-check-lg submit" onMouseDown={handleEnter} />
      </span>
    </span>
  );
};

export default memo(EditEntityText);
